import { SectionContainer } from '@/pages/shared-components/SectionContainer'
import { SyncExportV3 } from './SyncExportV3'
import { SyncFileUploader } from './SyncFileUploader'

export function ActionsSection({
  files,
  setFiles,
  hasFiles,
}: {
  files: File[]
  setFiles: (files: File[]) => void
  hasFiles: boolean
}) {
  if (hasFiles) return null
  return (
    <SectionContainer title="Import & Export App configuration">
      {/* <div className="grid grid-cols-2 items-center gap-x-5 pt-10"> */}
      <div className="flex w-full flex-col items-center gap-y-10 pt-[15vh]">
        <div className="flex h-full w-full max-w-[768px] flex-col items-center gap-y-2">
          <h3 className="font-bold">Import:</h3>
          <SyncFileUploader files={files} onFilesChange={setFiles} />
        </div>
        <div className="flex h-full w-full max-w-[768px] flex-col items-center gap-y-2">
          <h3 className="font-bold">Export:</h3>
          <SyncExportV3 />
        </div>
      </div>
    </SectionContainer>
  )
}
